var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.elem)?_c('v-col',{attrs:{"sm":"12","md":_vm.nbCol}},_vm._l((_vm.keys_col),function(key){return _c('v-row',{key:key.value,staticClass:"pa-3",class:key.class},[_c('span',{staticClass:"font-weight-bold indigo--text"},[_vm._v(_vm._s(key.text))]),_c('v-spacer'),_c('span',{staticClass:"mr-6"},[_vm._v(_vm._s(_vm.elem[key.value]))])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }